import { render, staticRenderFns } from "./Loading1.vue?vue&type=template&id=ceb67d04"
import script from "./Loading1.vue?vue&type=script&lang=js"
export * from "./Loading1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports